import { Component, OnInit } from '@angular/core';
import { ToastrService } from '@shared/services/toastr.service';
import { AuthService } from '@shared/services/auth.service';
import { Country, CountryService } from '@shared/services/country.service';
import { Location, NgFor, NgIf } from '@angular/common';
import { HelpComponent } from '@shared/components/help/help.component';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { LabelComponent } from '@shared/components/label/label.component';
import { SwitchComponent } from '@shared/components/switch/switch.component';
import { FeatureFlagDirective } from '@shared/utils/feature-flag.directive';
import {
  CreateOrganizationRequest,
  OrganizationInfo,
  OrganizationService,
} from '@shared/services/organization.service';

@Component({
  selector: 'app-add-edit-organization',
  templateUrl: './add-edit-organization.component.html',
  styleUrls: ['./add-edit-organization.component.scss'],
  imports: [
    HelpComponent,
    NgIf,
    FormsModule,
    NgFor,
    TranslatePipe,
    LabelComponent,
    SwitchComponent,
    FeatureFlagDirective,
  ],
})
export class AddEditOrganizationComponent implements OnInit {
  organization: CreateOrganizationRequest;
  countries: Country[] = [];
  loading: boolean;

  disableValidate = false;

  constructor(
    private readonly organizationService: OrganizationService,
    private readonly auth: AuthService,
    private readonly toastr: ToastrService,
    private readonly countryService: CountryService,
    private readonly location: Location,
  ) {}

  async ngOnInit() {
    await this.countryService.init();
    this.countries = this.countryService.getCountries();

    this.organization = this.emptyOrganization();
  }

  emptyOrganization(): OrganizationInfo {
    return {
      name: '',
      countryCode: 'FR',
      requireMfa: false
    };
  }

  onCreate() {
    this.disableValidate = true;
    this.organizationService.createOrganization(this.organization).subscribe({
      next: async () => {
        // reload organizations list
        await this.auth.loadOrganizations();
        this.back();
      },
      error: () => {
        this.disableValidate = false;
        this.toastr.error();
      },
    });
  }


  back() {
    this.location.back();
  }

  canValidate() {
    return !this.disableValidate && this.organization.name;
  }
}
